<div>
  <router-outlet (activate)="event($event)"></router-outlet>
</div>
